
import { mixins, Options } from 'vue-class-component';
import CartWidgetMixin from '@/mixins/cartWidget';
import { IToken } from '../api/models/token';
import LazyImage from './LazyImage.vue';

@Options({
  components: {
    LazyImage
  },
  props: {
    token: {
      type: Object,
      required: true
    }
  }
})
export default class MTokenAddToCart extends mixins(CartWidgetMixin) {
  token: IToken;
  currentProductId = '';

  get delegateCashIcon() {
    return require('@/assets/images/delegate-cash-icon.png');
  }

  get brokenImageIcon() {
    return require('@/assets/images/broken-image-icon.png');
  }
}
